import React, { createContext } from 'react'
import PropTypes from 'prop-types'
import { useRef, useCallback, useContext } from 'sb-hooks'
import { getRandomId } from 'common/helpers'

import { AccordionContext } from './Accordion'


const AccordionItemContext = createContext({})

const AccordionItem = (props) => {
  const { children } = props

  const { active, setActive } = useContext(AccordionContext)

  const ids = useRef({
    buttonId: getRandomId('button'),
    panelId: getRandomId('panel'),
  })

  const { buttonId, panelId } = ids.current

  const handleButtonClick = useCallback(({ isOpen }) => {
    setActive(isOpen ? buttonId : null)
  }, [ buttonId, setActive ])

  const state = {
    buttonId,
    panelId,
    isOpen: active === buttonId,
  }

  return (
    <AccordionItemContext.Provider value={{ state, setState: handleButtonClick }}>
      {
        typeof children === 'function'
          ? children({ isOpen: state.isOpen })
          : children
      }
    </AccordionItemContext.Provider>
  )
}

AccordionItem.propTypes = {
  children: PropTypes.oneOfType([ PropTypes.func, PropTypes.node ]),
}


export { AccordionItemContext }

export default AccordionItem
